const SvgSupplyChain1 = (props) => (
  <>
    <defs />
    <path d="M10.83 31.56h341.08v341.08H10.83z" strokeWidth={0} fill="none" />
    <path
      d="M352 32H64c-17.67 0-32 14.33-32 32s14.33 32 32 32h224M352 352H64c-17.67 0-32-14.33-32-32s14.33-32 32-32h224M80.52 160H304c17.67 0 32-14.33 32-32s-14.33-32-32-32H64M287.48 224H64c-17.67 0-32-14.33-32-32s14.33-32 32-32h240M80.52 288H304c17.67 0 32-14.33 32-32s-14.33-32-32-32H64"
      fill="none"
      stroke="#001d6c"
      strokeMiterlimit={10}
      strokeWidth="3px"
    />
    <circle cx={352} cy={32} r={8} fill="#001d6c" strokeWidth={0} />
    <circle cx={192} cy={96} r={8} fill="#0062ff" strokeWidth={0} />
    <circle cx={192} cy={96} r={24} fill="none" stroke="#001d6c" strokeMiterlimit={10} />
    <circle cx={192} cy={160} r={8} fill="#0062ff" strokeWidth={0} />
    <circle cx={192} cy={160} r={24} fill="none" stroke="#001d6c" strokeMiterlimit={10} />
    <circle cx={192} cy={224} r={8} fill="#0062ff" strokeWidth={0} />
    <circle cx={192} cy={224} r={24} fill="none" stroke="#001d6c" strokeMiterlimit={10} />
    <circle cx={192} cy={288} r={8} fill="#0062ff" strokeWidth={0} />
    <circle cx={192} cy={288} r={24} fill="none" stroke="#001d6c" strokeMiterlimit={10} />
    <circle cx={352} cy={352} r={8} fill="#001d6c" strokeWidth={0} />
  </>
);

export default SvgSupplyChain1;
